import React from 'react'
import { useNavigate } from 'react-router';
import { orderSummaryProps } from '../Order/orderSummaryProps';
import { useState } from "react";
import { toastNotify } from '../../../Helper';
import { apiResponse, cartItemModel, userModel } from '../../../Interfaces';
import { SD_Status } from '../../../Utility/SD';
import { useCreateOrderMutation } from '../../../Apis/orderApi';
import jwtDecode from 'jwt-decode';

const PaymentForm = ({ data, userInput }: orderSummaryProps) => {
  const [netAmount, setNetTotal] = useState(data.cartTotal)
  const [createOrder] = useCreateOrderMutation();
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate()

   function paymentGateway() {
    var options = {
        key: "rzp_test_5eMt9t8O214gAD",
        key_secret: "G7Fb19D7rCWj0BPPOnI8vOsG",
        amount: netAmount? netAmount* 100 : 0,
        currency: "INR",
        name: "Paying to Pasigo",
        handler: async function (response: any) {
            if (response.razorpay_payment_id) {
              setIsProcessing(true);
              const result = response.razorpay_payment_id
              if (result.error) {
                // Show error to your customer (for example, payment details incomplete)
                toastNotify("An unexpected error occured.", "error");
                setIsProcessing(false);
              } else {
                let grandTotal = 0;
                let totalItems = 0;
                const orderDetailsDTO: any = [];
                data.cartItems?.forEach((item: cartItemModel) => {
                  const tempOrderDetail: any = {};
                  tempOrderDetail["menuItemId"] = item.menuItem?.id;
                  tempOrderDetail["quantity"] = item.quantity;
                  tempOrderDetail["itemName"] = item.menuItem?.name;
                  tempOrderDetail["price"] = item.menuItem?.price;
                  orderDetailsDTO.push(tempOrderDetail);
                  grandTotal += item.quantity! * item.menuItem?.price!;
                  totalItems += item.quantity!;
                });
                const localToken = sessionStorage.getItem("token");
                if (localToken) {
                   const { fullName, id, email, role }: userModel = jwtDecode(localToken);
                   const response: apiResponse = await createOrder({
                    pickupName: userInput.name,
                    pickupPhoneNumber: userInput.phoneNumber,
                    pickupEmail: userInput.email,
                    pasigoUserId: id,
                    totalItems: totalItems,
                    orderTotal: grandTotal,
                    orderDetailsDTO: orderDetailsDTO,
                    stripePaymentIntentID: result,
                    applicationUserId: data.userId,
                    status: SD_Status.CONFIRMED
                  });
                  if (response) {
                    if (response.data?.result.status === SD_Status.CONFIRMED) {
                      navigate(
                        `/order/orderConfirmed/${response.data.result.orderHeaderId}`
                      );
                    } else {
                      navigate("/failed");
                    }
                  }
                  }
                
          
                
              }
              setIsProcessing(false);
            }
        },

    };
    var pay = new (window as any).Razorpay(options);
    pay.open();
}
   async function cod(){
    let grandTotal = 0;
    let totalItems = 0;
    const orderDetailsDTO: any = [];
    data.cartItems?.forEach((item: cartItemModel) => {
      const tempOrderDetail: any = {};
      tempOrderDetail["menuItemId"] = item.menuItem?.id;
      tempOrderDetail["quantity"] = item.quantity;
      tempOrderDetail["itemName"] = item.menuItem?.name;
      tempOrderDetail["price"] = item.menuItem?.price;
      orderDetailsDTO.push(tempOrderDetail);
      grandTotal += item.quantity! * item.menuItem?.price!;
      totalItems += item.quantity!;
    });
    const localToken = sessionStorage.getItem("token");
    if (localToken) {
       const { fullName, id, email, role }: userModel = jwtDecode(localToken);
       const response: apiResponse = await createOrder({
        pickupName: userInput.name,
        pickupPhoneNumber: userInput.phoneNumber,
        pickupEmail: userInput.email,
        pasigoUserId: id,
        totalItems: totalItems,
        orderTotal: grandTotal,
        orderDetailsDTO: orderDetailsDTO,
        stripePaymentIntentID: "cod",
        applicationUserId: data.userId,
        status: SD_Status.CONFIRMED
      });
      if (response) {
        if (response.data?.result.status === SD_Status.CONFIRMED) {
          navigate(
            `/order/orderConfirmed/${response.data.result.orderHeaderId}`
          );
        } else {
          navigate("/failed");
        }
      }
    }
   }

  return (
    <>
    <div className='d-none d-md-block d-lg-block d-xl-block'>
    <div className='container'>
      <div className='row'>
      <div className='col'>
      <div className="card" style={{width: "18rem"}}>
    <div className="card-body">
    <h5 className="card-title col">COD</h5>
    </div>
      </div>
      </div>
      <div className='col my-auto'>
      <i onClick={()=>{cod()}} className="bi bi-box-arrow-up-right" style={{fontSize: "25px", cursor: "pointer"}}></i>
      </div>
      </div>
      
      
    </div>
    <div className='container mt-4'>
      <div className='row'>
      <div className='col'>
      <div className="card" style={{width: "18rem"}}>
    <div className="card-body">
    <h5 className="card-title col">Pay Online</h5>
    </div>
      </div>
      </div>
      <div className='col my-auto'>
      <i onClick={()=>{paymentGateway()}} className="bi bi-wallet2" style={{fontSize: "25px", cursor: "pointer"}}
       ></i>
      </div>
      </div>
      
      
    </div>
    </div>
    <div className='d-block d-md-none d-lg-none d-xl-none'>
    <div className='container d-flex'>
      <div className='row'>
      <div className='col-2 my-auto'>
      <i onClick={()=>{cod()}} className="bi bi-box-arrow-up-right" style={{fontSize: "25px", cursor: "pointer"}}></i>
      </div>
      <div className='col-2'>
      <div className="card" style={{width: "15rem"}}>
    <div className="card-body">
    <h5 className="card-title col">COD</h5>
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      
    </div>
    <div className='container mt-4'>
      <div className='row'>
      <div className='col-2 my-auto'>
      <i onClick={()=>{paymentGateway()}} className="bi bi-wallet2" style={{fontSize: "25px", cursor: "pointer"}}
       ></i>
      </div>
      <div className='col-2'>
      <div className="card" style={{width: "15rem"}}>
    <div className="card-body">
    <h5 className="card-title col">Pay Online</h5>
    </div>
      </div>
      </div>
      </div>
      
      
    </div>
    </div>
    </>
  )
}

export default PaymentForm